export default {
  brandColor1: '#231F20',
  complimentaryColor1: '#fff',
  brandColor2: '#EAAC4C',
  complimentaryColor2: '#fff',
};
